export const RESET_REDUX_STATE = 'GLOBAL/RESET_REDUX_STATE';

export function resetReduxState() {
    return {
        type: RESET_REDUX_STATE
    };
}
